import { useState, useEffect, useCallback } from "react";

export interface DataGridSettings {
  alternatingRows: boolean;
  oddRowColor: string;
  evenRowColor: string;
  cellPadding: number;
  stackColumnHeaders: boolean;
}

export const DEFAULT_SETTINGS: DataGridSettings = {
  alternatingRows: true,
  oddRowColor: "#e8edf5",
  evenRowColor: "#ffffff",
  cellPadding: 16,
  stackColumnHeaders: false,
};

const STORAGE_KEY = "datagrid-global-settings";
const CHANGE_EVENT = "datagrid-settings-changed";

export function loadSettings(): DataGridSettings {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return { ...DEFAULT_SETTINGS, ...JSON.parse(stored) };
    }
  } catch (e) {
    console.log(e);
  }
  return { ...DEFAULT_SETTINGS };
}

export function saveSettings(settings: DataGridSettings): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
    window.dispatchEvent(new CustomEvent(CHANGE_EVENT));
  } catch (e) {
    console.log(e);
  }
}

export function useDataGridSettings() {
  const [settings, setSettings] = useState<DataGridSettings>(loadSettings);

  useEffect(() => {
    const handler = () => setSettings(loadSettings());
    window.addEventListener(CHANGE_EVENT, handler);
    return () => window.removeEventListener(CHANGE_EVENT, handler);
  }, []);

  const updateSettings = useCallback((newSettings: DataGridSettings) => {
    setSettings(newSettings);
    saveSettings(newSettings);
  }, []);

  return { settings, updateSettings };
}
